import React from 'react';
// import { Sprout, Users, Briefcase, DollarSign, Phone, Mail, MapPin, CheckCircle, Target, Factory, HeartHandshake, Wrench, Package, Info, Tractor, Spade } from 'lucide-react';
import MissionVision from './mission-vission';
import OurStrength from './strength';
import PainPoints from './Painpoints';
// --- Data Definitions ---

// css
  const css = `
:root{ --max-width:1200px; --green:#16a34a; --muted:#6b7280; --bg:#f8fafc }
*{box-sizing:border-box}
body,html,#root{height:100%;margin:0;font-family:Inter, system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', Arial;background:var(--bg);color:#0f172a}
.gs-navbar{position:fixed;top:0;left:0;width:100%;background:#fff;box-shadow:0 2px 8px rgba(15,23,42,0.06);z-index:60}
.gs-nav-inner{max-width:var(--max-width);margin:0 auto;display:flex;justify-content:space-between;align-items:center;padding:14px}
.gs-logo-text{font-weight:700;color:var(--green);font-size:20px}
.gs-nav-links a{margin-left:18px;text-decoration:none;color:#0f172a;font-weight:500}
.gs-nav-links a:hover{color:var(--green)}
.gs-hero{height:65vh;background-image:url('https://images.unsplash.com/photo-1501004318641-b39e6451bec6');background-size:cover;background-position:center;display:flex;align-items:center;justify-content:center}
.gs-hero-overlay{position:relative;inset:0;background:rgba(0,0,0,0.35);width:100%;display:flex;align-items:center;justify-content:center;flex-direction:column;padding:20px;text-align:center}
.gs-hero-overlay h1{color:#fff;font-size:36px;margin:0;line-height:1.05;font-weight:800}
.gs-hero-overlay p{margin-top:14px;color:#e6eef0;max-width:720px}
.gs-category-strip{max-width:var(--max-width);margin:-40px auto 0;display:flex;gap:12px;background:#fff;padding:14px;border-radius:12px;box-shadow:0 8px 24px rgba(2,6,23,0.06);overflow:auto;align-items:center}
.gs-cat{display:flex;flex-direction:column;align-items:center;justify-content:center;padding:10px 12px;border-radius:10px;background:transparent;border:1px solid transparent;cursor:pointer;min-width:96px}
.gs-cat:hover{background:#f0fdf4}
.gs-cat-icon{font-size:24px}
.gs-cat-title{font-size:12px;margin-top:6px;font-weight:600;color:#064e3b}
.gs-cat.active{background:#d1fae5;border-color:var(--green)}
.gs-products-section{padding:56px 16px;max-width:var(--max-width);margin:0 auto}
.gs-section-title{text-align:center;font-size:28px;margin-bottom:28px;font-weight:700;color:#064e3b}
.gs-products-grid{display:grid;grid-template-columns:repeat(1,1fr);gap:22px}
@media(min-width:600px){.gs-products-grid{grid-template-columns:repeat(2,1fr)}}
@media(min-width:1000px){.gs-products-grid{grid-template-columns:repeat(3,1fr)}}
.gs-card{background:#fff;border-radius:12px;padding:16px;box-shadow:0 6px 18px rgba(2,6,23,0.04);transition:transform .18s ease,box-shadow .18s ease;display:flex;flex-direction:column}
.gs-card:hover{transform:translateY(-6px);box-shadow:0 10px 30px rgba(2,6,23,0.08);cursor:pointer}
.gs-card-media{height:180px;border-radius:8px;background:#f3f4f6;display:flex;align-items:center;justify-content:center;color:var(--muted);margin-bottom:12px;overflow:hidden}
.gs-card-title{margin:0;font-size:18px;font-weight:700;color:#0f172a}
.gs-card-desc{color:var(--muted);margin-top:8px;font-size:14px}
.gs-about-section{padding:48px 16px;background:#fff}
.gs-about-grid{display:grid;grid-template-columns:1fr;gap:18px}
@media(min-width:800px){.gs-about-grid{grid-template-columns:1fr 1fr}}
.gs-about-heading{font-size:20px;margin-bottom:8px}
.gs-contact-section{padding:48px 16px}
.gs-contact-inner{background:#fff;border-radius:10px;padding:28px;box-shadow:0 6px 18px rgba(2,6,23,0.04);text-align:center}
.gs-contact-name{font-weight:700;color:#064e3b;font-size:18px}
.gs-contact-phone{color:var(--muted);margin-top:6px}
.gs-contact-email{color:var(--green);display:inline-block;margin-top:8px}
.gs-modal-backdrop{position:fixed;inset:0;background:rgba(0,0,0,0.5);display:flex;align-items:center;justify-content:center;z-index:100}
.gs-modal{width:90%;max-width:760px;background:#fff;border-radius:12px;padding:18px;box-shadow:0 20px 60px rgba(2,6,23,0.3)}
.gs-modal-header{display:flex;justify-content:space-between;align-items:flex-start}
.gs-modal-close{background:transparent;border:0;font-size:22px;cursor:pointer;color:#374151}
.gs-modal-media{height:200px;background:#f3f4f6;border-radius:8px;overflow:hidden}
.gs-modal-desc{color:#374151;margin-top:12px}
.gs-modal-actions{margin-top:12px;display:flex;gap:8px}
.gs-btn-primary{display:inline-block;padding:8px 14px;border-radius:8px;text-decoration:none;font-weight:600;background:var(--green);color:#fff}
.gs-btn-secondary{padding:8px 14px;border-radius:8px;border:1px solid #e5e7eb;background:#fff}
.gs-footer{padding:20px 0;margin-top:36px;background:#fff;border-top:1px solid #e6edf0;text-align:center}
`;

// --- Components ---
const HeroSection = () => (
  <div className="gs-page">
        <style>{css}</style>
    <section id="home" className="gs-hero">
      <div className="gs-hero-overlay">
        {/* <h1>Agriculture Begins With Good Machines</h1> */}
        <h1>Cultivating Wisdom, Growing Nature</h1>
        <p>Next-generation technology crafted for efficiency and modern farming.</p>
      </div>
    </section>
    </div>
);
const AppV2 = () => {
  return (
    <div>
        <HeroSection />
        <MissionVision />
        <OurStrength />
        <PainPoints />
    </div>
  );
};

export default AppV2;